import { QA_CONTENT } from 'constants/controllers'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import url from 'libraries/front-end-core/core/url'

export default new Controller({
  name: 'LegacyQaContentRedirect',
  route: ':aol/:flavour/qa/:sectionId(/:focusedId(/hl))',
  controller (Router, { params }) {
    const target = url(QA_CONTENT, params)
    replaceUrl(target)
  }
})
